import { stringToSearchPlayers } from "utils/helpers";
import { dedupParticipantes } from "utils/participantes-dedup";
import { COLECAO_INICIATIVAS } from "utils/constants";
import { api } from "./api";
import { dedupedFetch, invalidateCache } from "./cache";

interface BuscarEntregasParams {
  player: string;
}

interface BuscarEntregasPorGestorParams {
  prefixo: string;
}

const getEntregasCacheKey = (params: BuscarEntregasParams) =>
  `entregas-${params.player}`;

export const invalidarCacheEntregas = (params: BuscarEntregasParams) => {
  invalidateCache(getEntregasCacheKey(params));
};

/** O `team` cru pode repetir a matrícula quando o gestor também é participante. */
const dedupTimeDasEntregas = (entregas: any) => {
  if (!Array.isArray(entregas)) return entregas;

  return entregas.map((entrega) =>
    entrega?.team ? { ...entrega, team: dedupParticipantes(entrega.team) } : entrega
  );
};

export const buscarEntregas = async (params: BuscarEntregasParams) => {
  return dedupedFetch(getEntregasCacheKey(params), async () => {
    const { data } = await api.post("find/entregas", params);
    return dedupTimeDasEntregas(data);
  }, 30_000);
};

export const buscarEntregasPorGestor = async (params: BuscarEntregasParams) => {
  try {
    const { data } = await api.post("find/tasks_manager", params);
    return dedupTimeDasEntregas(data);
  } catch (error) {
    console.error("Erro ao buscar entregas por gestor:", error);
    throw error;
  }
};


// A listagem de `find/tasks_manager` omite description/result/team/indicator;
// com `taskId` o aggregate devolve o documento completo, necessário para que o
// PUT de aprovação (atualizarEntrega) não apague esses campos.
const buscarEntregaCompletaDoGestor = async (player: string, taskId: string) => {
  const { data } = await api.post("find/tasks_manager", { player, taskId });
  return Array.isArray(data) ? data[0] : null;
};

export const buscarIniciativasElbbDoGestor = async (player: string) => {
  try {
    const entregas = await buscarEntregasPorGestor({ player });
    const elbb = (entregas || []).filter((e: any) => e.categoryPremio === "ELBB");
    const completas = await Promise.all(
      elbb.map((e: any) => buscarEntregaCompletaDoGestor(player, e._id))
    );
    return completas.filter(Boolean);
  } catch (error) {
    console.error("Erro ao buscar iniciativas ELBB do gestor:", error);
    return [];
  }
};

export const buscarEntregasPorGestorPorPrefixo = async (params: BuscarEntregasPorGestorParams) => {
  try {
    const { data } = await api.post("find/tasks_by_prefixo", params);
    return dedupTimeDasEntregas(data);
  } catch (error) {
    console.error("Erro ao buscar entregas por gestor por prefixo:", error);
    throw error;
  }
};


export async function findPlayer(search?: string) {
  let _search = search;

  if (typeof _search === "string") {
    _search = stringToSearchPlayers(_search);
  }

  try {
    const payload = {
      search: _search,
    };

    const { data } = await api.post(`find/players`, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export async function findManagers(
  search?: string,
  cod?: number[],
  all = false,
) {
  let _search = search;

  if (typeof _search === "string") {
    _search = stringToSearchPlayers(_search);
  }

  try {
    const payload = {
      search: _search,
      cod,
      all,
    };

    const { data } = await api.post(`find/gestores`, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export const atualizarEntrega = async (params: any) => {
  try {
    const { data } = await api.put(`database/${COLECAO_INICIATIVAS}`, params);
    return data;
  } catch (error) {
    console.error("Erro ao atualizar entrega:", error);
    throw error;
  }
};
